export const translations = {
  name: {
    pt: 'Nome',
    en: 'Name',
    es: 'Nombre',
    de: 'Name',
  },
  originIbge: {
    pt: 'IBGE Origem',
    en: 'IBGE Origin',
    es: 'Origen IBGE',
    de: 'IBGE Herkunft',
  },
  origin: {
    pt: 'Origem',
    en: 'Origin',
    es: 'Origen',
    de: 'Herkunft',
  },
  destinationIbge: {
    pt: 'IBGE Destino',
    en: 'IBGE Destination',
    es: 'Destino IBGE',
    de: 'IBGE Ziel',
  },
  destination: {
    pt: 'Destino',
    en: 'Destination',
    es: 'Destino',
    de: 'Ziel',
  },
  carrier: {
    pt: 'Transportadora',
    en: 'Carrier',
    es: 'Transportista',
    de: 'Spediteur',
  },
  status: {
    pt: 'Status',
    en: 'Status',
    es: 'Estado',
    de: 'Status',
  },
};